module.exports = __webpack_public_path__ + "static/img/pic1.d20c43b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic1.jpg
// module id = gZAi
// module chunks = 0